import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import * as String from "../../strings";
import { Anchor } from "./PhoneNumber.styles";
var PhoneNumber = function(param) {
    var className = param.className, phoneNumber = param.phoneNumber, language = param.language, icon = param.icon;
    var pn = String.parsePhoneNumber(phoneNumber, language);
    return /*#__PURE__*/ _jsxs(Anchor, {
        className: className,
        href: pn.url,
        target: "_system",
        children: [
            icon,
            /*#__PURE__*/ _jsx("span", {
                children: pn.national
            })
        ]
    });
};
export { PhoneNumber };
